import { useTranslation } from "react-i18next";
import { PermissionsGate } from "../../../../../common/components/PermissionsGate";
import { ADMIN_ROUTES, PERMISSIONS } from "../../../../../common/constants";
import { IconAnnouncements, IconDevices, IconSystemcheck, IconUsers } from "../../Icons";
import NavigationButton from "../NavigationButton/NavigationButton";

const AdminControls = () => {
    const { t } = useTranslation("common");

    return (
        <PermissionsGate>
            <div className="flex items-center justify-center flex-col gap-4 mt-8 md:mt-10">
                <NavigationButton
                    href={ADMIN_ROUTES.SYSTEMCHECK}
                    label={t("systemcheck")}
                    icon={<IconSystemcheck />}
                />
                <NavigationButton
                    href={ADMIN_ROUTES.DEVICES}
                    label={t("devices")}
                    icon={<IconDevices />}
                />
                <NavigationButton
                    href={ADMIN_ROUTES.USERS}
                    label={t("users")}
                    icon={<IconUsers />}
                />
                <NavigationButton
                    href={ADMIN_ROUTES.MIGRATION}
                    label={t("migration")}
                    icon={"pi pi-arrow-right-arrow-left"}
                    iconClassName="text-3xl"
                />
                <PermissionsGate
                    globalPermissions={[PERMISSIONS.ANNOUNCEMENT.READ]}
                >
                    <NavigationButton
                        href={ADMIN_ROUTES.ANNOUNCEMENTS}
                        label={t("announcements")}
                        icon={<IconAnnouncements />}
                    />
                </PermissionsGate>
                <NavigationButton
                    href={ADMIN_ROUTES.FLOORPLANS}
                    label={t("floorplans")}
                    icon={"pi pi-map"}
                    iconClassName="text-3xl"
                />
            </div>
        </PermissionsGate>
    );
};

export default AdminControls;
